import React from 'react';
import { connect, useDispatch } from 'react-redux';
import renderHTML from 'react-render-html';
import { setMixcloudSlug } from '../store/actions/actions';
import { Link } from 'react-router-dom';
import moment from 'moment';

function Programme(props){
    const { title, acf, content } = props;
    const dispatch = useDispatch();
    console.log(props)
    console.log( title)

    const handlePlayClick = (e,slug) => {
        e.preventDefault();
        dispatch(setMixcloudSlug(slug));
    };
    //const formattedDate = moment(acf.date_premiere_diffusion, 'YYYYMMDD').format('DD/MM/YYYY');

    return (
        <main id="site-content">
            <h1> {renderHTML(title.rendered)} </h1>
            <div id="programme-header">                 
                <div id="programme-header-body">
                    {acf.programme_nom} | Première diffusion: {moment(acf.date_premiere_diffusion, 'YYYYMMDD').format('DD/MM/YYYY')}
                    <div id="programme-resume">
                        <p>{renderHTML(acf.programme_resume)}</p>
                    </div>
                    <div className="listen-to-podcast">
                        <Link
                            to="#"
                            data-show-id={acf.programme_lien_mixcloud_iframe}
                            className="button button-primary"
                            id="btn-play"
                            onClick={(e) =>
                                handlePlayClick(e, `${acf.programme_lien_mixcloud_iframe}`)
                            }
                        >
                            Ecouter ce podcast
                        </Link>

                        
                    </div>

                    <Link
                        to={acf.programme_lien_mixcloud}
                        target="_blank"
                        className="link-more-info">
                            Ce podcast sur mixcloud
                    </Link>
                    
                </div>
                <div id="programme-header-side">
                    
                        <div id="programme-visuel">
                        <img src={acf.programme_visuel.url} className="img-fluid" alt={title.rendered} />
                        </div>
                    
                </div>
            </div>
            <div id="programme-body">
                <h2>Sommaire</h2>
                {renderHTML(content.rendered)}
            </div>
            
        </main>
    )

}
//export default Programme


const mapStateToProps = (state) => {
    return {
        mixcloudSlug: state.mixcloudSlug,
    };
};

export default connect(mapStateToProps)(Programme);